import React from 'react'

import pill from "./../../../UI/general/pill.svg"

interface Props {
  galleryData: any,
  colorsData: any,
  isGallery: boolean,
  handleGalleriesSelection: any,
  handleCloseGalleryModal: any
}

interface State {
  isCollapsed: boolean
  galleryItemSelected: string,
  rgbaColor: any,
  galleryIndexSelected: number,
}

class GalleryModalMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      isCollapsed: true,
      galleryItemSelected: "",
      rgbaColor: "",
      galleryIndexSelected: -1
    }
  }

  componentDidMount(): void {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(this.props.colorsData.main_buttons)
    this.setState({
      rgbaColor: result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : ""
    })
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    if(this.props.isGallery !== prevProps.isGallery){
      this.setState({
        galleryIndexSelected: -1,
        galleryItemSelected: ''
      })
    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isGallery ? 'gallery-modal-container-mobile fade-in':'gallery-modal-container-mobile fade-out'}>
          
          <div 
            className='close-gallery-modal-mobile' 
            onClick={() => {
              this.setState({
                galleryIndexSelected: -1
              })
              this.props.handleCloseGalleryModal()
            }}
          >
            <img src={pill} alt=""/> 
          </div>

          {
            <div className={this.state.isCollapsed ? 'gallery-modal-btns-container':'gallery-modal-btns-container-collapsed'}>
              {
                    this.props.isGallery ?
                    <div className={!this.state.isCollapsed ? "gallery-general-sidebar-collapsed-mobile":"gallery-general-sidebar-mobile"}>
                        <div className='gallery-name-mobile'  onClick={() => {this.setState({galleryIndexSelected: -1, galleryItemSelected: ''})}}>GALERÍA GENERAL</div>
                        <div className='breadcrumbs-gallery-container'>
                          {
                            this.state.galleryItemSelected !== '' ?
                            <div>
                              {'/ ' + this.state.galleryItemSelected}
                            </div>:null
                          }
                        </div>
                        <div className="gallery-categories-container-mobile">
                            { this.state.galleryIndexSelected === -1 ?
                                this.props.galleryData.map((galleryCategory: any, index: number) =>
                                    <div className="individual-gallery-container-mobile" onClick={() => {this.setState({
                                      galleryItemSelected: galleryCategory.name,
                                      galleryIndexSelected: index
                                      })}}>
                                        <div className="indiividual-gallery-image-mobile">
                                            <img src={"https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/"+galleryCategory.background} alt=""/>
                                        </div>
                                        <div 
                                        className="individual-gallery-name-mobile"
                                        >
                                            <div>
                                             {galleryCategory.name.toUpperCase()}
                                            </div>
                                        </div>
                                    </div>
                                ): null
                            }
                        </div>
                        {
                            this.state.galleryIndexSelected !== -1 ?
                            <div className="gallerie-modal-items-container-mobile">
                                {
                                    this.props.galleryData[this.state.galleryIndexSelected].galleries.galleries.map((galleries: any, index: number) => 
                                    galleries.map((gallery: any) => 
                                      <div className="gallerie-modal-items-individual-mobile" onClick={() => {this.props.handleGalleriesSelection(gallery)}}>
                                        <img src={gallery.icon} alt=""/>
                                        <div className="gallerie-modal-name-mobile">{gallery.name}</div>
                                      </div>
                                      )
                                    )
                                }
                            </div>:null
                        }
                    </div>:null
                }
            </div>
          }
        </div>
      )
  }
}

export default GalleryModalMobile